import WhatsAppSipCallEventsAPI from 'dashboard/api/whatsappSip/callEvents';

const state = {
  records: [],
  meta: {},
  channelEvents: [],
  uiFlags: {
    isFetching: false,
    isFetchingChannel: false,
  },
};

const getters = {
  getRecords: $state => $state.records,
  getMeta: $state => $state.meta,
  getChannelEvents: $state => $state.channelEvents,
  getUIFlags: $state => $state.uiFlags,
};

const mutations = {
  SET_RECORDS($state, records) {
    $state.records = records;
  },
  SET_META($state, meta) {
    $state.meta = meta;
  },
  SET_CHANNEL_EVENTS($state, events) {
    $state.channelEvents = events;
  },
  SET_UI_FLAG($state, flag) {
    $state.uiFlags = { ...$state.uiFlags, ...flag };
  },
};

const actions = {
  async fetch({ commit }, params = {}) {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const { data } = await WhatsAppSipCallEventsAPI.getCallEvents(params);
      commit('SET_RECORDS', data.call_events || []);
      commit('SET_META', data.meta || {});
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  async fetchByChannel({ commit }, channelId) {
    commit('SET_UI_FLAG', { isFetchingChannel: true });
    try {
      const { data } = await WhatsAppSipCallEventsAPI.getByChannel(channelId);
      commit('SET_CHANNEL_EVENTS', data.call_events || []);
    } finally {
      commit('SET_UI_FLAG', { isFetchingChannel: false });
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
